<script setup>
import { useI18n } from "vue-i18n";
import { FormInput } from "@Components/Form";

defineProps(["modelValue"]);
defineEmits(["update:modelValue"]);

const { t: __ } = useI18n();
</script>

<template>
    <div class="max-w-xs">
        <FormInput v-model="modelValue.length" type="number" :label="__('Nombre de contenu à afficher')" min="0" :hint="__('0 pour l\'infini')" />
    </div>
</template>
